jQuery.fn.extend({
  hideExcessItems: function() {
    return this.each(function() {
      var $el = $(this);
      var listItems = $el.children('li');
      if (listItems.length > 5) {
        listItems.slice(5).hide();
        $el.append('<a href="#" class="more">&#x25BC; More</a>')
      }
    });
  }
});

$(document).on('click', '#company-projects-smart-lists ul#quick-lists li a', function(){
  var list = $(this).data('type');

  appendLoader();

  window.location.href = window.location.origin + window.location.pathname +  '?project_type=' + list;
});

jQuery(document).ready(function() {
  var fields = [
    'started_at',
    'ended_at',
    'created_at',
    'updated_at',
    'design_completed_at',
    'main_contractor_tender_released_at',
    'main_contractor_tender_submitted_at',
    'main_contractor_awarded_at',
    'mep_contract_awarded_at',
    'construction_started_at',
  ]

  var datepickerSelectors = fields.map(function(field) {
    return ["#" + field + "_from", "#" + field + "_to"]
  })

  $(_.flatten(datepickerSelectors).join(', ')).datepicker({ dateFormat: "yy-mm-dd", changeMonth: true, changeYear: true});
});

window.onpopstate = function(event) {
  if(window.location.pathname == '/companies' || window.location.pathname == '/projects'){
    $.getScript(document.location.href)
  }
};

jQuery(document).ready(function() {
  $(document).on('click', '#projects-table th', function(){
    var selected_option = $(this);
    var direction = selected_option.data('direction');

    if(selected_option.hasClass('sort-asc')){
      direction = 'desc';
    }
    else if(selected_option.hasClass('sort-desc')){
      direction = 'asc';
    }

    if($('#order_by').length > 0){
      $('#order_by').val(selected_option.data('value'));
      $('#order_direction').val(direction);
    }
    else{
      var order_by = $("<input>", { type: "hidden", name: "order_by", id: "order_by", value: selected_option.data('value') });
      var order_direction = $("<input>", { type: "hidden", name: "order_direction", id: "order_direction", value: direction });
      $('form#advanced_search').append(order_by, order_direction);
    }
  })

  $('#search_tenders').on('click', function(){
    $('#business-activities-section, #issuing-companies-section').hide();
    $(this).closest('form').attr('action', '/directory')
  });

  $('a.more').on('click', function(e) {
    $(this).parent().children('li').show();
    $(this).parent().parent().append('<a href="#" class="less">&#x25B2; Less</a>')
    $(this).remove();
    e.preventDefault();
  });

  $('a.less').on('click', function(e) {
    $(this).prev().hideExcessItems();
    $(this).remove();
    e.preventDefault();
  });

  $('#business_activities').select2({
    multiple: true,
    separator: ',',
    placeholder: "Enter any activity",
    width: '100%',
    quietMillis: 100,
    ajax: {
      url: window.location.pathname+"/business_activities.json",
      dataType: 'json',
      data: function(term, page) {
        return {
          business_activity: term,
          page_limit: 10,
          page: page,
        };
      },
      results: function(data, page) {
        var more = (page * 10) < data.pop();
        return {results: data }
      }
    },
    initSelection : function (element, callback) {
      var data = [];

      $(element.val().split(",")).each(function () {
        data.push({id: this, text: this});
      });

      callback(data);
    }
  }).on("change", function(e) {
    $(".select2-search-field input").val('');
  });

});
